module.exports = __webpack_public_path__ + "img/form-background-blur.a0874389.svg";